import { render } from "./BaseCard.vue?vue&type=template&id=d41cdc06&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=d41cdc06&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d41cdc06"

export default script